import {
  Component,
  forwardRef,
  Input,
  OnChanges,
  SimpleChanges
} from '@angular/core';
import {
  FormArray,
  FormControl,
  FormGroup,
  NG_VALIDATORS,
  NG_VALUE_ACCESSOR
} from '@angular/forms';
import {
  AgpFormUtil,
  CvaFormGroupComponent,
  ResetOptions
} from '@liberty-financial/agp-shared';

import { ContactSummary } from '@features/contacts/models';

@Component({
  selector: 'spark-contacts-company-directors',
  templateUrl: './directors.component.html',
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => CompanyDirectorsComponent),
      multi: true
    },
    {
      provide: NG_VALIDATORS,
      useExisting: forwardRef(() => CompanyDirectorsComponent),
      multi: true
    }
  ]
})
export class CompanyDirectorsComponent
  extends CvaFormGroupComponent<string[], { director: ContactSummary }[]>
  implements OnChanges
{
  @Input() contacts: ContactSummary[] = [];
  @Input() isRequired = false;

  expandedIndex = -1;
  form = new FormArray<
    FormGroup<{ director: FormControl<ContactSummary | null> }>
  >([]);
  formGroup = new FormGroup({
    directors: this.form
  });

  ngOnChanges(changes: SimpleChanges) {
    if (changes.isRequired) {
      AgpFormUtil.Validators.updateRequiredIfNecessary(this.form, changes.isRequired.currentValue);
    }
  }

  protected reset(opts?: ResetOptions | undefined): void {
    this.form?.reset(undefined, opts);
  }

  protected transformToModel = (
    value: { director: ContactSummary }[]
  ): string[] => {
    return value.map((d) => d.director?.id);
  };

  protected transformToForm = (v: string[]): { director: ContactSummary }[] => {
    const result: { director: ContactSummary }[] = [];
    v.forEach((id) => {
      const director = this.contacts.find((c) => c.id === id);
      if (director) {
        this.addDirector();
        result.push({ director });
      }
    });
    return result;
  };

  addDirector(): void {
    this.form.push(
      new FormGroup({
        director: new FormControl<ContactSummary | null>(null)
      })
    );
    this.expandedIndex = this.form.length - 1;
  }

  removeDirector(i: number): void {
    this.form.removeAt(i);
  }
}
